import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Document, Page, pdfjs } from 'react-pdf';

import { useParams, useNavigate, Link } from "react-router-dom";
import { Page as ShopifyPage, 
         PageActions, 
         FormLayout, 
         Card, 
         BlockStack, 
         Text, 
         Divider,
         TextField,
         ChoiceList,
         Checkbox,
         Select,
         DataTable,
         Tabs,
         Layout,
         ButtonGroup,
         Grid,
         Button,
         Box,
         DescriptionList,
         List,
         ColorPicker,
         hsbToHex
       } from '@shopify/polaris';
import {
  SaveIcon
} from '@shopify/polaris-icons';

import LoadingSpinner from '../partials/LoadingSpinner';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import PageFooter from '../partials/PageFooter';
import TemplateLineOrderContainer from './TemplateLineOrderContainer';
import PresetSection from './PresetSection';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { indexBarcodeTemplates, updateBarcodeTemplate, previewBarcodeTemplate, getTemplateFungibles, getTemplateLineSettings } from '../../redux/actions/barcodeTemplates';


const EditTemplateForm = ({ shopUrl, payload, getTemplates, allTemplates, newBarcodeTemplate, saveTemplateChanges, barcodeTemplates, loadPreview, templateDetails, newTemplate, loadFungibles, loadLineSettings, templateFungibles, templateLineSettings, requiresRefresh }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;
  
  let navigate = useNavigate();
  const { uuid } = useParams();

  const [tabSelected, setTabSelected] = useState(0);
  const [lineOptions, setLineOptions] = useState([
    {
      label: 1, value: 0
    },
    {
      label: 2, value: 1
    },
    {
      label: 3, value: 2
    },
    {
      label: 4, value: 3
    }
  ]);

  const [tabs, setTabs] = useState([
    {
      id: 'line-1',
      content: 'Line 1',
      panelId: 0
    },
    {
      id: 'line-2',
      content: 'Line 2',
      panelId: 1,
    },
    {
      id: 'line-3',
      content: 'Line 3',
      panelId: 2,
    },
    {
      id: 'line-4',
      content: 'Line 4',
      panelId: 3,
    }
  ]);

  const handleTabChange = (selectedTabIndex) => {
    setTabSelected(selectedTabIndex);
  }

  const [submitted, setSubmitted] = useState(false);

  const [validTemplate, setValidTemplate] = useState(true);
  const [validationErrors, setValidationErrors] = useState([]);

  const [templateSaved, setTemplateSaved] = useState(true);

  const [templateForm, setTemplateForm] = useState(barcodeTemplates?.templates?.find(template => template.uuid === uuid));

  const [templateName, setTemplateName] = useState(templateForm?.template_name);
  const [rotate, setRotate] = useState(templateForm?.rotate);
  const [printType, setPrintType] = useState(templateForm?.print_type);
  const [length, setLength] = useState(templateForm?.length);
  const [width, setWidth] = useState(templateForm?.width);
  
  const [sizeMeasurement, setSizeMeasurement] = useState(templateForm?.size_measurement);
  const [lineCount, setLineCount] = useState(templateForm?.line_count);

  const [lineSettings, setLineSettings] = useState([]);

  const [pageWidth, setPageWidth] = useState(templateForm?.page_definition?.page_width || 8.5);
  const [pageLength, setPageLength] = useState(templateForm?.page_definition?.page_length || 11);
  const [pageXMargin, setPageXMargin] = useState(templateForm?.page_definition?.page_x_margin || 0.0);
  const [pageYMargin, setPageYMargin] = useState(templateForm?.page_definition?.page_y_margin || 0.0);
  const [pageRows, setPageRows] = useState(templateForm?.page_definition?.rows || 15);
  const [pageColumns, setPageColumns] = useState(templateForm?.page_definition?.columns || 3);
  const [pageLabelXPadding, setPageLabelXPadding] = useState(templateForm?.page_definition?.label_x_padding || 0.0);
  const [pageLabelYPadding, setPageLabelYPadding] = useState(templateForm?.page_definition?.label_y_padding || 0.0);

  const [barcodeEnabled, setBarcodeEnabled] = useState(null);
  const [barcodeLine, setBarcodeLine] = useState(null);
  const [barcodeHeightPercent, setBarcodeHeightPercent] = useState(null);

  const [storeLogoEnabled, setStoreLogoEnabled] = useState(false);
  const [storeLogoLine, setStoreLogoLine] = useState(0);
  const [storeLogoHeightPercent, setStoreLogoHeightPercent] = useState(50);

  const [barcodeSymbolEnabled, setBarcodeSymbolEnabled] = useState(null);
  const [barcodeSymbolLine, setBarcodeSymbolLine] = useState(null);
  const [barcodeSymbolPriority, setBarcodeSymbolPriority] = useState(null);
  const [barcodeSymbolLabelEnabled, setBarcodeSymbolLabelEnabled] = useState(null);
  const [barcodeSymbolLabelOverride, setBarcodeSymbolLabelOverride] = useState(null);

  const [skuEnabled, setSkuEnabled] = useState(null);
  const [skuLine, setSkuLine] = useState(null);
  const [skuPriority, setSkuPriority] = useState(null);
  const [skuLabelEnabled, setSkuLabelEnabled] = useState(null);
  const [skuLabelOverride, setSkuLabelOverride] = useState(null);

  const [productNameEnabled, setProductNameEnabled] = useState(null);
  const [productNameLine, setProductNameLine] = useState(null);
  const [productNamePriority, setProductNamePriority] = useState(null);
  const [productNameLabelEnabled, setProductNameLabelEnabled] = useState(null);
  const [productNameLabelOverride, setProductNameLabelOverride] = useState(null);

  const [optionOneEnabled, setOptionOneEnabled] = useState(null);
  const [optionOneLine, setOptionOneLine] = useState(null);
  const [optionOnePriority, setOptionOnePriority] = useState(null);
  const [optionOneLabelEnabled, setOptionOneLabelEnabled] = useState(null);
  const [optionOneLabelOverride, setOptionOneLabelOverride] = useState(null);

  const [optionTwoEnabled, setOptionTwoEnabled] = useState(null);
  const [optionTwoLine, setOptionTwoLine] = useState(null);
  const [optionTwoPriority, setOptionTwoPriority] = useState(null);
  const [optionTwoLabelEnabled, setOptionTwoLabelEnabled] = useState(null);
  const [optionTwoLabelOverride, setOptionTwoLabelOverride] = useState(null);

  const [optionThreeEnabled, setOptionThreeEnabled] = useState(null);
  const [optionThreeLine, setOptionThreeLine] = useState(null);
  const [optionThreePriority, setOptionThreePriority] = useState(null);
  const [optionThreeLabelEnabled, setOptionThreeLabelEnabled] = useState(null);
  const [optionThreeLabelOverride, setOptionThreeLabelOverride] = useState(null);

  const [priceEnabled, setPriceEnabled] = useState(null);
  const [priceLine, setPriceLine] = useState(null);
  const [pricePriority, setPricePriority] = useState(null);
  const [priceLabelEnabled, setPriceLabelEnabled] = useState(null);
  const [priceLabelOverride, setPriceLabelOverride] = useState(null);

  const [brandEnabled, setBrandEnabled] = useState(null);
  const [brandLine, setBrandLine] = useState(null);
  const [brandPriority, setBrandPriority] = useState(null);
  const [brandLabelEnabled, setBrandLabelEnabled] = useState(null);
  const [brandLabelOverride, setBrandLabelOverride] = useState(null);

  const [arbitraryTextEnabled, setArbitraryTextEnabled] = useState(false);
  const [arbitraryTextLine, setArbitraryTextLine] = useState(0);
  const [arbitraryTextPriority, setArbitraryTextPriority] = useState(8);
  const [arbitraryTextLabelEnabled, setArbitraryTextLabelEnabled] = useState(false);
  const [arbitraryTextLabelOverride, setArbitraryTextLabelOverride] = useState('');

  const [activePreviewuri, setActivePreviewUri] = useState(null);

  const [previewGenerating, setPreviewGenerating] = useState(false);
  const [enqueuePreviewGeneration, setEnqueuePreviewGeneration] = useState(null);

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  useEffect(() => {
    getTemplates(shopUrl, payload);
  }, []);

  useEffect(() => {
    if(newTemplate) { navigate(-1) };
  }, [newTemplate]);

  useEffect(() => {
    let updatedTemplate = templateForm || {};
    updatedTemplate['line_settings'] = lineSettings;

    if(barcodeTemplates.lineSettingsLoaded && allTemplates.length > 0) {  
      handlePreview(updatedTemplate, null);
    }
  }, [lineSettings]);

  useEffect(() => {
    if(templateLineSettings && barcodeTemplates.lineSettingsLoaded) {
      setLineSettings(templateLineSettings);
    }
  }, [templateLineSettings]);

  useEffect(() => {
    if(barcodeTemplates.templates.length > 0) {
      let loadedTemplate = barcodeTemplates?.templates?.find(template => template.uuid === uuid);

      setTemplateForm(loadedTemplate);

      setTemplateName(loadedTemplate.template_name);
      setRotate(loadedTemplate.rotate);
      setPrintType(loadedTemplate.print_type);
      setLength(loadedTemplate.length);
      setWidth(loadedTemplate.width);
      setSizeMeasurement(loadedTemplate.size_measurement);
      setLineCount(loadedTemplate.line_count);

      setPageWidth(loadedTemplate.page_definition?.page_width);
      setPageLength(loadedTemplate.page_definition?.page_length);
      setPageXMargin(loadedTemplate.page_definition?.page_x_margin);
      setPageYMargin(loadedTemplate.page_definition?.page_y_margin);
      setPageRows(loadedTemplate.page_definition?.rows);
      setPageColumns(loadedTemplate.page_definition?.columns);
      setPageLabelXPadding(loadedTemplate.page_definition?.label_x_padding);
      setPageLabelYPadding(loadedTemplate.page_definition?.label_y_padding);

      if(!barcodeTemplates.fungiblesLoaded && !barcodeTemplates.lineSettingsLoaded) {
        loadFungibles(shopUrl, payload, uuid);
        loadLineSettings(shopUrl, payload, uuid);
      }

      setBarcodeEnabled(loadedTemplate.barcode.enabled);
      loadedTemplate.barcode_enabled = loadedTemplate.barcode.enabled;
      setBarcodeLine(loadedTemplate.barcode.line);
      loadedTemplate.barcode_line = loadedTemplate.barcode.line;
      setBarcodeHeightPercent(loadedTemplate.barcode_height_percent);
      setStoreLogoEnabled(loadedTemplate.store_logo.enabled);
      loadedTemplate.store_logo_enabled = loadedTemplate.store_logo.enabled;
      setStoreLogoLine(loadedTemplate.store_logo.line);
      loadedTemplate.store_logo_line = loadedTemplate.store_logo.line;
      setStoreLogoHeightPercent(loadedTemplate.store_logo_height_percent);

      setBarcodeSymbolEnabled(loadedTemplate.barcode_symbol.enabled);
      loadedTemplate.barcode_symbol_enabled = loadedTemplate.barcode_symbol.enabled;
      setBarcodeSymbolLine(loadedTemplate.barcode_symbol.line);
      loadedTemplate.barcode_symbol_line = loadedTemplate.barcode_symbol.line;
      setBarcodeSymbolPriority(loadedTemplate.barcode_symbol.priority);
      loadedTemplate.barcode_symbol_priority = loadedTemplate.barcode_symbol.priority;
      setBarcodeSymbolLabelEnabled(loadedTemplate.barcode_symbol.label_enabled);
      loadedTemplate.barcode_symbol_label_enabled = loadedTemplate.barcode_symbol.label_enabled;
      setBarcodeSymbolLabelOverride(loadedTemplate.barcode_symbol.label_override);
      loadedTemplate.barcode_symbol_label_override = loadedTemplate.barcode_symbol.label_override;

      setSkuEnabled(loadedTemplate.sku?.enabled);
      loadedTemplate.sku_enabled = loadedTemplate.sku.enabled;
      setSkuLine(loadedTemplate.sku?.line);
      loadedTemplate.sku_line = loadedTemplate.sku.line;
      setSkuPriority(loadedTemplate.sku?.priority);
      loadedTemplate.sku_priority = loadedTemplate.sku.priority;
      setSkuLabelEnabled(loadedTemplate.sku?.label_enabled);
      loadedTemplate.sku_label_enabled = loadedTemplate.sku.label_enabled;
      setSkuLabelOverride(loadedTemplate.sku?.label_override);
      loadedTemplate.sku_label_override = loadedTemplate.sku.label_override;

      setProductNameEnabled(loadedTemplate.product_name.enabled);
      loadedTemplate.product_name_enabled = loadedTemplate.product_name.enabled;
      setProductNameLine(loadedTemplate.product_name.line);
      loadedTemplate.product_name_line = loadedTemplate.product_name.line;
      setProductNamePriority(loadedTemplate.product_name.priority);
      loadedTemplate.product_name_priority = loadedTemplate.product_name.priority;
      setProductNameLabelEnabled(loadedTemplate.product_name.label_enabled);
      loadedTemplate.product_name_label_enabled = loadedTemplate.product_name.label_enabled;
      setProductNameLabelOverride(loadedTemplate.product_name.label_override);
      loadedTemplate.product_name_label_override = loadedTemplate.product_name.label_override;

      setOptionOneEnabled(loadedTemplate.option_1.enabled);
      loadedTemplate.option_1_enabled = loadedTemplate.option_1.enabled;
      setOptionOneLine(loadedTemplate.option_1.line);
      loadedTemplate.option_1_line = loadedTemplate.option_1.line;
      setOptionOnePriority(loadedTemplate.option_1.priority);
      loadedTemplate.option_1_priority = loadedTemplate.option_1.priority;
      setOptionOneLabelEnabled(loadedTemplate.option_1.label_enabled);
      loadedTemplate.option_1_label_enabled = loadedTemplate.option_1.label_enabled;
      setOptionOneLabelOverride(loadedTemplate.option_1.label_override);
      loadedTemplate.option_1_label_override = loadedTemplate.option_1.label_override;

      setOptionTwoEnabled(loadedTemplate.option_2.enabled);
      loadedTemplate.option_2_enabled = loadedTemplate.option_2.enabled;
      setOptionTwoLine(loadedTemplate.option_2.line);
      loadedTemplate.option_2_line = loadedTemplate.option_2.line;
      setOptionTwoPriority(loadedTemplate.option_2.priority);
      loadedTemplate.option_2_priority = loadedTemplate.option_2.priority;
      setOptionTwoLabelEnabled(loadedTemplate.option_2.label_enabled);
      loadedTemplate.option_2_label_enabled = loadedTemplate.option_2.label_enabled;
      setOptionTwoLabelOverride(loadedTemplate.option_2.label_override);
      loadedTemplate.option_2_label_override = loadedTemplate.option_2.label_override;

      setOptionThreeEnabled(loadedTemplate.option_3.enabled);
      loadedTemplate.option_3_enabled = loadedTemplate.option_3.enabled;
      setOptionThreeLine(loadedTemplate.option_3.line);
      loadedTemplate.option_3_line = loadedTemplate.option_3.line;
      setOptionThreePriority(loadedTemplate.option_3.priority);
      loadedTemplate.option_3_priority = loadedTemplate.option_3.priority;
      setOptionThreeLabelEnabled(loadedTemplate.option_3.label_enabled);
      loadedTemplate.option_3_label_enabled = loadedTemplate.option_3.label_enabled;
      setOptionThreeLabelOverride(loadedTemplate.option_3.label_override);
      loadedTemplate.option_3_label_override = loadedTemplate.option_3.label_override;

      setPriceEnabled(loadedTemplate.price.enabled);
      loadedTemplate.price_enabled = loadedTemplate.price.enabled;
      setPriceLine(loadedTemplate.price.line);
      loadedTemplate.price_line = loadedTemplate.price.line;
      setPricePriority(loadedTemplate.price.priority);
      loadedTemplate.price_priority = loadedTemplate.price.priority;
      setPriceLabelEnabled(loadedTemplate.price.label_enabled);
      loadedTemplate.price_label_enabled = loadedTemplate.price.label_enabled;
      setPriceLabelOverride(loadedTemplate.price.label_override);
      loadedTemplate.price_label_override = loadedTemplate.price.label_override;

      setBrandEnabled(loadedTemplate.brand.enabled);
      loadedTemplate.brand_enabled = loadedTemplate.brand.enabled;
      setBrandLine(loadedTemplate.brand.line);
      loadedTemplate.brand_line = loadedTemplate.brand.line;
      setBrandPriority(loadedTemplate.brand.priority);
      loadedTemplate.brand_priority = loadedTemplate.brand.priority;
      setBrandLabelEnabled(loadedTemplate.brand.label_enabled);
      loadedTemplate.brand_label_enabled = loadedTemplate.brand.label_enabled;
      setBrandLabelOverride(loadedTemplate.brand.label_override);
      loadedTemplate.brand_label_override = loadedTemplate.brand.label_override;

      setArbitraryTextEnabled(loadedTemplate.arbitrary_text.enabled);
      loadedTemplate.arbitrary_text_enabled = loadedTemplate.arbitrary_text.enabled;
      setArbitraryTextLine(loadedTemplate.arbitrary_text.line);
      loadedTemplate.arbitrary_text_line = loadedTemplate.arbitrary_text.line;
      setArbitraryTextPriority(loadedTemplate.arbitrary_text.priority);
      loadedTemplate.arbitrary_text_priority = loadedTemplate.arbitrary_text.priority;
      setArbitraryTextLabelEnabled(loadedTemplate.arbitrary_text.label_enabled);
      loadedTemplate.arbitrary_text_label_enabled = loadedTemplate.arbitrary_text.label_enabled;
      setArbitraryTextLabelOverride(loadedTemplate.arbitrary_text.label_override);
      loadedTemplate.arbitrary_text_label_override = loadedTemplate.arbitrary_text.label_override;

      if(barcodeTemplates.lineSettingsLoaded) {
        setLineSettings(templateLineSettings);
        loadedTemplate.line_settings = templateLineSettings;
      }

      // console.log(loadedTemplate);

      if(barcodeTemplates.lineSettingsLoaded && allTemplates.length > 0) {
        handlePreview(loadedTemplate, null);
      }
    }
  }, [allTemplates]);

  const changeLineCount = (event) => {
    let updatedTemplate = templateForm || {};
    let updatedLineSettings = lineSettings;

    let newLineCount = parseInt(event);
    let newLineOptions = [];
    let newTabs = [];

    let isIncrease = newLineCount > (lineCount || 0);

    if(isIncrease) {
      let difference = newLineCount - (lineCount || 0);

      for(let i = 0; i < difference; i++){
        updatedLineSettings.push({
          render_strategy: 'truncate',
          font_size: 12,
          alignment: 'left',
          text_color: {
            hue: 120,
            brightness: 0,
            saturation: 1,
          },
          text_color_hex: '000000',
          position: (lineCount || 0) + i
        })
      }
    } else {
      let difference = (lineCount || 0) - newLineCount;

      for(let i = 0; i < difference; i++){
        updatedLineSettings.pop();
      }
    }

    for (let i = 0; i < newLineCount; i++) {
      newLineOptions.push({
        label: i + 1, value: i
      });

      newTabs.push({
        id: `line-${i + 1}`,
        content: `Line ${i + 1}`,
        panelId: i
      })
    }

    setLineCount(newLineCount);
    setLineOptions(newLineOptions);
    setTabs(newTabs);

    updatedTemplate['line_count'] = newLineCount;
    updatedTemplate['line_settings'] = updatedLineSettings;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(templateForm, null);
  }

  const setNumeric = (setField, event, templateId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = event.replace(/[^\d.-]+/g, '');

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    setField(valueNumeric);
    updatedTemplate[templateId] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(templateForm, null);
  }

  const setInteger = (setField, event, templateId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = parseInt(event) || 0;

    if(valueNumeric > 99) {
      valueNumeric = 99
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    setField(valueNumeric);
    updatedTemplate[templateId] = valueNumeric;

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(templateForm, null);
  }

  const switchBoolean = (setField, field, key) => {
    let updatedTemplate = templateForm;
    updatedTemplate[key] = !field;

    setField(!field);
    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    handlePreview(templateForm, null);
  }

  const handleSwitchRotate = () => {
    let updatedTemplate = templateForm;
    updatedTemplate['rotate'] = !rotate;

    setRotate(!rotate);
    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
    
    handlePreview(templateForm, null);
  }

  const setMeasurements = (measurement) => {
    let selectedMeasurement = measurement;

    if (Array.isArray(measurement)) {
      selectedMeasurement = measurement[0];
    }

    let updatedTemplate = templateForm;
    updatedTemplate['size_measurement'] = selectedMeasurement;

    console.log(selectedMeasurement);

    setTemplateForm(updatedTemplate);

    setSizeMeasurement(selectedMeasurement);

    handlePreview(templateForm, null);
    setTemplateSaved(false);
  }

  const setFieldValue = (setField, value, templateId) => {
    let updatedTemplate = templateForm;
    updatedTemplate[templateId] = value;
    setTemplateForm(updatedTemplate);
    setField(value);
    setTemplateSaved(false);

    handlePreview(templateForm, null);
  }

  const setPriority = (updatedTemplate, setFunction, value, key) => {
    setFunction(value);

    updatedTemplate[key] = value;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    // handlePreview(updatedTemplate, null);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    saveTemplateChanges(shopUrl, payload, templateForm);
    setTemplateSaved(true);
  }

  const handlePreview = (templateForm, values) => {
    validateTemplate(templateForm);

    if(!previewGenerating && !barcodeTemplates.isPreviewFetching) {
      setPreviewGenerating(true);
      setEnqueuePreviewGeneration(null);
      loadPreview(shopUrl, payload, templateForm, values);
    } else {
      setEnqueuePreviewGeneration(templateForm);
    }
  }

  const readyPreview = () => {
    setPreviewGenerating(false);
    if(enqueuePreviewGeneration) {
      handlePreview(enqueuePreviewGeneration, null);
    }
  }

  const flashPageFields = () => {
    let widthElement = document.querySelector('#width-field');
    let lengthElement = document.querySelector('#length-field');
    let measurementsElement = document.querySelector('#measurements-field');
    let pageElements = document.querySelector('#page-fields');

    widthElement.classList.add("blink-action");
    lengthElement.classList.add("blink-action");
    measurementsElement.classList.add("blink-action");
    pageElements.classList.add("blink-action");

    setTimeout(() => {
      widthElement.classList.remove("blink-action");
      lengthElement.classList.remove("blink-action");
      measurementsElement.classList.remove("blink-action");
      pageElements.classList.remove("blink-action");
    }, 1000);
  }

  const setRenderStrategy = (position, value) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, render_strategy: value[0] } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setFontSize = (position, value) => {
    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, font_size: value.replace(/[^\d-]+/g, '') } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setAlignment = (position, value) => {
    let updatedTemplate = templateForm;

    // console.log(value[0]);

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, alignment: value[0] } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const setTextColor = (position, value) => {
    console.log(value);
    console.log(hsbToHex(value));

    let updatedTemplate = templateForm;

    setLineSettings(
      lineSettings.map((setting) =>
        setting.position === position ? { ...setting, text_color: value, text_color_hex: hsbToHex(value) } : { ...setting }
      )
    )

    updatedTemplate['line_settings'] = lineSettings;

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);
  }

  const increasePriority = (element, lineElements) => {
    let updatedTemplate = templateForm;

    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === 0) { return; }

    let el = lineElements[elementIndex - 1];
    let elementNewPriority = lineElements[elementIndex - 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementNewPriority, 'sku_priority') }
    if(element.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementNewPriority, 'price_priority') }
    if(element.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementOldPriority, 'sku_priority') }
    if(el.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementOldPriority, 'price_priority') }
    if(el.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    handlePreview(updatedTemplate, null);

    let titleElement = document.querySelector(`#ordering-title-${elementNewPriority}`);
    let rowElement = document.querySelector(`#ordering-row-${elementNewPriority}`);

    titleElement.classList.add("blink-action");
    rowElement.classList.add("blink-action");

    setTimeout(() => {
      titleElement.classList.remove("blink-action");
      rowElement.classList.remove("blink-action");
    }, 1000);
  }
  
  const decreasePriority = (element, lineElements) => {
    let updatedTemplate = templateForm;

    let elementIndex = lineElements.findIndex((el) => el === element);

    if(elementIndex === (lineElements.length - 1)) { return; }

    let el = lineElements[elementIndex + 1];
    let elementNewPriority = lineElements[elementIndex + 1].priority;
    let elementOldPriority = element.priority;

    if(element.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementNewPriority, 'barcode_symbol_priority') }
    if(element.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementNewPriority, 'sku_priority') }
    if(element.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementNewPriority, 'product_name_priority') }
    if(element.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementNewPriority, 'option_1_priority') }
    if(element.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementNewPriority, 'option_2_priority') }
    if(element.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementNewPriority, 'option_3_priority') }
    if(element.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementNewPriority, 'price_priority') }
    if(element.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementNewPriority, 'brand_priority') }
    if(element.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementNewPriority, 'arbitrary_text_priority') }

    if(el.element === 'Barcode Symbol') { setPriority(updatedTemplate, setBarcodeSymbolPriority, elementOldPriority, 'sku_priority') }
    if(el.element === 'SKU') { setPriority(updatedTemplate, setSkuPriority, elementOldPriority, 'barcode_symbol_priority') }
    if(el.element === 'Product Name') { setPriority(updatedTemplate, setProductNamePriority, elementOldPriority, 'product_name_priority') }
    if(el.element === 'Variation Option 1') { setPriority(updatedTemplate, setOptionOnePriority, elementOldPriority, 'option_1_priority') }
    if(el.element === 'Variation Option 2') { setPriority(updatedTemplate, setOptionTwoPriority, elementOldPriority, 'option_2_priority') }
    if(el.element === 'Variation Option 3') { setPriority(updatedTemplate, setOptionThreePriority, elementOldPriority, 'option_3_priority') }
    if(el.element === 'Price') { setPriority(updatedTemplate, setPricePriority, elementOldPriority, 'price_priority') }
    if(el.element === 'Brand') { setPriority(updatedTemplate, setBrandPriority, elementOldPriority, 'brand_priority') }
    if(el.element === 'Branding Text') { setPriority(updatedTemplate, setArbitraryTextPriority, elementOldPriority, 'arbitrary_text_priority') }

    handlePreview(updatedTemplate, null);

    let titleElement = document.querySelector(`#ordering-title-${elementNewPriority}`);
    let rowElement = document.querySelector(`#ordering-row-${elementNewPriority}`);

    titleElement.classList.add("blink-action");
    rowElement.classList.add("blink-action");

    setTimeout(() => {
      titleElement.classList.remove("blink-action");
      rowElement.classList.remove("blink-action");
    }, 1000);
  }

  const setPageValue = (setField, event, fieldId) => {
    let updatedTemplate = templateForm;
    let valueNumeric = event.replace(/[^\d.-]+/g, '') || 0.0;

    if(valueNumeric > 999.9) {
      valueNumeric = 999.9
    }

    if(valueNumeric < 0) {
      valueNumeric = 0
    }

    let valueInteger = parseInt(event) || 0;

    if(['rows', 'columns'].includes(fieldId)) {
      setField(valueInteger);
      updatedTemplate['page_definition'][fieldId] = valueInteger;
    } else {
      setField(valueNumeric);
      updatedTemplate['page_definition'][fieldId] = parseFloat(valueNumeric);
    }

    setTemplateSaved(false);
    setTemplateForm(updatedTemplate);

    validateTemplate(updatedTemplate);
  }

  const handleSwitchPageType = (newType) => {
    let updatedTemplate = templateForm;

    // console.log(newType);
    updatedTemplate['print_type'] = newType;
    setPrintType(newType);

    if (newType === 'sheet') {
      setRotate(false);
      updatedTemplate['rotate'] = false;
    }

    setTemplateForm(updatedTemplate);
    setTemplateSaved(false);

    handlePreview(updatedTemplate, null);
  }

  const validateTemplate = (templateForm) => {
    let valid = true;
    let updatedValidationErrors = [];

    // Must have a template name
    if (!templateForm['template_name']) {
      valid = false;
      updatedValidationErrors.push('Template name missing.');
    }

    // Must have label lengths and widths
    if (!templateForm['width'] ||  !templateForm['length']) {
      valid = false;
      updatedValidationErrors.push('Templates must have defined label length and width');
    }

    // If it's a sheet, it must have page length, page width, rows and columns
    if (templateForm['print_type'] === 'sheet') {
      if (!templateForm.page_definition.page_length || !templateForm.page_definition.page_width || !templateForm.page_definition.columns || !templateForm.page_definition.rows) {
        valid = false;
        updatedValidationErrors.push('Sheets must have defined page length, page width, columns and rows.');
      }
    }

    setValidationErrors(updatedValidationErrors);
    setValidTemplate(valid);
  }

  return(
    <ShopifyPage
      title="Edit Label Template"
      primaryAction={<Button icon={SaveIcon} disabled={validationErrors.length > 0} variant="primary" onClick={() => handleSubmit()}>Save Template</Button>}
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/templates' + window.location.search}}
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      { barcodeTemplates.status === 'success' && !barcodeTemplates.isFetching && templateFungibles && templateLineSettings &&
        <>
          <Layout>
            <Layout.Section>
              <FormLayout>
                <BlockStack gap="400">
                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingLg" as="h5">Label Template Options</Text>
                      <DescriptionList
                        items={[
                          {
                            term: 'Template name',
                            description:
                              <TextField value={templateName} onChange={(e) => setFieldValue(setTemplateName, e, 'template_name')} autoComplete="off" />,
                          },
                          {
                            term: 'Print Type',
                            description:  <>
                                            <ButtonGroup variant="segmented">
                                              <Button pressed={printType==='roll'} onClick={() => handleSwitchPageType('roll')}>
                                                Roll
                                              </Button>
                                              <Button pressed={printType==='sheet'} onClick={() => handleSwitchPageType('sheet')}>
                                                Sheet
                                              </Button>
                                            </ButtonGroup>
                                            { printType === 'roll' &&
                                              <Checkbox
                                                label="Rotate Labels"
                                                checked={rotate}
                                                onChange={() => handleSwitchRotate()}
                                              />
                                            }
                                          </>,
                          },
                          {
                            term: <Box id='measurements-field'><Text>Label Measurement Units</Text></Box>,
                            description:
                              <ChoiceList
                                choices={[
                                  {label: 'in', value: 'in'},
                                  {label: 'cm', value: 'cm'},
                                  {label: 'mm', value: 'mm'},
                                ]}
                                selected={sizeMeasurement}
                                onChange={(e) => setMeasurements(e)}
                              />,
                          },
                          {
                            term: 
                              <Box id='width-field'><Text>Label Width</Text></Box>,
                            description:
                              <TextField type="number" value={width} onChange={(e) => setNumeric(setWidth, e, 'width')} autoComplete="off" />
                          },
                          {
                            term: <Box id='length-field'><Text>Label Length</Text></Box>,
                            description:
                              <TextField type="number" value={length} onChange={(e) => setNumeric(setLength, e, 'length')} autoComplete="off" />,
                          },
                          {
                            term: 'Line Count',
                            description:
                              <TextField type="number" value={lineCount || ''} onChange={(e) => setInteger(changeLineCount, e, 'line_count')} autoComplete="off" />,
                          },
                        ]}
                      />

                      { printType === 'sheet' &&
                        <>
                          <Divider />
                          <Text variant="headingLg" as="h5">Page Options</Text>
                          <FormLayout.Group condensed>

                            <Grid>
                              <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
                                <PresetSection
                                  setTemplateForm={setTemplateForm}
                                  templateForm={templateForm}
                                  setLength={setLength}
                                  setWidth={setWidth}
                                  setPageWidth={setPageWidth}
                                  setPageLength={setPageLength}
                                  setPageXMargin={setPageXMargin}
                                  setPageYMargin={setPageYMargin}
                                  setPageRows={setPageRows}
                                  setPageColumns={setPageColumns}
                                  setPageLabelXPadding={setPageLabelXPadding}
                                  setPageLabelYPadding={setPageLabelYPadding}
                                  setSizeMeasurement={setSizeMeasurement}
                                  handlePreview={handlePreview}
                                  flashPageFields={flashPageFields}
                                />
                              </Grid.Cell>

                              <Grid.Cell columnSpan={{xs: 6, sm: 3, md: 3, lg: 6, xl: 6}}>
                                <Box id='page-fields'>
                                  <TextField type="number" value={pageWidth} label="Page Width" onChange={(e) => setPageValue(setPageWidth, e, 'page_width')} autoComplete="off" />
                                  <TextField type="number" value={pageLength} label="Page Length" onChange={(e) => setPageValue(setPageLength, e, 'page_length')} autoComplete="off" />

                                  <TextField type="number" value={pageXMargin} label="X Margin" onChange={(e) => setPageValue(setPageXMargin, e, 'page_x_margin')} autoComplete="off" />
                                  <TextField type="number" value={pageYMargin} label="Y Margin" onChange={(e) => setPageValue(setPageYMargin, e, 'page_y_margin')} autoComplete="off" />

                                  <TextField type="number" value={pageRows} label="Page Rows" onChange={(e) => setPageValue(setPageRows, e, 'rows')} autoComplete="off" />
                                  <TextField type="number" value={pageColumns} label="Page Columns" onChange={(e) => setPageValue(setPageColumns, e, 'columns')} autoComplete="off" />

                                  <TextField type="number" value={pageLabelXPadding} label="Label X Padding" onChange={(e) => setPageValue(setPageLabelXPadding, e, 'label_x_padding')} autoComplete="off" />
                                  <TextField type="number" value={pageLabelYPadding} label="Label Y Padding" onChange={(e) => setPageValue(setPageLabelYPadding, e, 'label_y_padding')} autoComplete="off" />
                                </Box>
                              </Grid.Cell>
                            </Grid>

                          </FormLayout.Group>
                        </>
                      }
                      
                    </BlockStack>
                  </Card>

                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingLg" as="h5">Full Line Options</Text>

                      <DescriptionList
                        items={[
                          {
                            term: 'Barcode Line',
                            description:
                              <DataTable
                                columnContentTypes={[
                                  'text',
                                  'text',
                                  'text'
                                ]}
                                headings={[
                                  'Enabled',
                                  'Line',
                                  'Height % of label'
                                ]}
                                rows={[
                                  [
                                    <Checkbox
                                      checked={barcodeEnabled}
                                      onChange={() => switchBoolean(setBarcodeEnabled, barcodeEnabled, 'barcode_enabled')}
                                    />,
                                    <Select
                                      options={lineOptions}
                                      onChange={(e) => setInteger(setBarcodeLine, e, 'barcode_line')}
                                      value={barcodeLine}
                                    />,
                                    <TextField type="number" value={barcodeHeightPercent} label="" onChange={(e) => setNumeric(setBarcodeHeightPercent, e, 'barcode_height_percent')} autoComplete="off" />
                                  ]
                                ]}
                              />,
                          }
                        ]}
                      />

                      

                      {/*<Text>Store Logo Line</Text>
                      <DataTable
                        columnContentTypes={[
                          'text',
                          'text',
                          'text'
                        ]}
                        headings={[
                          'Enabled',
                          'Line',
                          'Height % of label'
                        ]}
                        rows={storeLogoRow}
                      />*/}

                      <Divider />

                      <DescriptionList
                        items={[
                          {
                            term: 'Branding Text Line',
                            description:
                              <DataTable
                                columnContentTypes={[
                                  'text',
                                  'text',
                                  'text'
                                ]}
                                headings={[
                                  'Enabled',
                                  'Line',
                                  'Text'
                                ]}
                                rows={[
                                  [
                                    <Checkbox
                                      checked={arbitraryTextEnabled}
                                      onChange={() => switchBoolean(setArbitraryTextEnabled, arbitraryTextEnabled, 'arbitrary_text_enabled')}
                                    />,
                                    <Select
                                      options={lineOptions}
                                      onChange={(e) => setInteger(setArbitraryTextLine, e, 'arbitrary_text_line')}
                                      value={arbitraryTextLine}
                                    />,
                                    <TextField value={arbitraryTextLabelOverride || ''} label="" onChange={(e) => setFieldValue(setArbitraryTextLabelOverride, e, 'arbitrary_text_label_override')} autoComplete="off" />
                                  ]
                                ]}
                              />,
                          }
                        ]}
                      />
                      
                    </BlockStack>
                  </Card>

                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingLg" as="h5">Label Line Parts</Text>
                      <DataTable
                        columnContentTypes={[
                          'text',
                          'text',
                          'text',
                          'text',
                          'text'
                        ]}
                        headings={[
                          'Enabled',
                          'Label Part',
                          'Line',
                          'Include Name',
                          'Name Override'
                        ]}
                        rows={[
                          [
                            <Checkbox
                              checked={barcodeSymbolEnabled}
                              onChange={() => switchBoolean(setBarcodeSymbolEnabled, barcodeSymbolEnabled, 'barcode_symbol_enabled')}
                            />,
                            'Barcode Symbol',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setBarcodeSymbolLine, e, 'barcode_symbol_line')}
                              value={barcodeSymbolLine}
                            />,
                            <Checkbox
                              checked={barcodeSymbolLabelEnabled}
                              onChange={() => switchBoolean(setBarcodeSymbolLabelEnabled, barcodeSymbolLabelEnabled, 'barcode_symbol_label_enabled')}
                            />,
                            <TextField value={barcodeSymbolLabelOverride || ''} label="" onChange={(e) => setFieldValue(setBarcodeSymbolLabelOverride, e, 'barcode_symbol_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={skuEnabled}
                              onChange={() => switchBoolean(setSkuEnabled, skuEnabled, 'sku_enabled')}
                            />,
                            'SKU',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setSkuLine, e, 'sku_line')}
                              value={skuLine}
                            />,
                            <Checkbox
                              checked={skuLabelEnabled}
                              onChange={() => switchBoolean(setSkuLabelEnabled, skuLabelEnabled, 'sku_label_enabled')}
                            />,
                            <TextField value={skuLabelOverride || ''} label="" onChange={(e) => setFieldValue(setSkuLabelOverride, e, 'sku_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={productNameEnabled}
                              onChange={() => switchBoolean(setProductNameEnabled, productNameEnabled, 'product_name_enabled')}
                            />,
                            'Product Name',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setProductNameLine, e, 'product_name_line')}
                              value={productNameLine}
                            />,
                            <Checkbox
                              checked={productNameLabelEnabled}
                              onChange={() => switchBoolean(setProductNameLabelEnabled, productNameLabelEnabled, 'product_name_label_enabled')}
                            />,
                            <TextField value={productNameLabelOverride || ''} label="" onChange={(e) => setFieldValue(setProductNameLabelOverride, e, 'product_name_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={optionOneEnabled}
                              onChange={() => switchBoolean(setOptionOneEnabled, optionOneEnabled, 'option_1_enabled')}
                            />,
                            'Variant Option 1',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setOptionOneLine, e, 'option_1_line')}
                              value={optionOneLine}
                            />,
                            <Checkbox
                              checked={optionOneLabelEnabled}
                              onChange={() => switchBoolean(setOptionOneLabelEnabled, optionOneLabelEnabled, 'option_1_label_enabled')}
                            />,
                            <TextField value={optionOneLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionOneLabelOverride, e, 'option_1_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={optionTwoEnabled}
                              onChange={() => switchBoolean(setOptionTwoEnabled, optionTwoEnabled, 'option_2_enabled')}
                            />,
                            'Variant Option 2',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setOptionTwoLine, e, 'option_2_line')}
                              value={optionTwoLine}
                            />,
                            <Checkbox
                              checked={optionTwoLabelEnabled}
                              onChange={() => switchBoolean(setOptionTwoLabelEnabled, optionTwoLabelEnabled, 'option_2_label_enabled')}
                            />,
                            <TextField value={optionTwoLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionTwoLabelOverride, e, 'option_2_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={optionThreeEnabled}
                              onChange={() => switchBoolean(setOptionThreeEnabled, optionThreeEnabled, 'option_3_enabled')}
                            />,
                            'Variant Option 3',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setOptionThreeLine, e, 'option_3_line')}
                              value={optionThreeLine}
                            />,
                            <Checkbox
                              checked={optionThreeLabelEnabled}
                              onChange={() => switchBoolean(setOptionThreeLabelEnabled, optionThreeLabelEnabled, 'option_3_label_enabled')}
                            />,
                            <TextField value={optionThreeLabelOverride || ''} label="" onChange={(e) => setFieldValue(setOptionThreeLabelOverride, e, 'option_3_label_override')} autoComplete="off" />
                          ],
                          [
                            <Checkbox
                              checked={priceEnabled}
                              onChange={() => switchBoolean(setPriceEnabled, priceEnabled, 'price_enabled')}
                            />,
                            'Price',
                            <Select
                              options={lineOptions}
                              onChange={(e) => setInteger(setPriceLine, e, 'price_line')}
                              value={priceLine}
                            />,
                            <Checkbox
                              checked={priceLabelEnabled}
                              onChange={() => switchBoolean(setPriceLabelEnabled, priceLabelEnabled, 'price_label_enabled')}
                            />,
                            <TextField value={priceLabelOverride || ''} label="" onChange={(e) => setFieldValue(setPriceLabelOverride, e, 'price_label_override')} autoComplete="off" />
                          ]
                          // [
                          //   <Checkbox
                          //     checked={brandEnabled}
                          //     onChange={() => switchBoolean(setBrandEnabled, brandEnabled, 'brand_enabled')}
                          //   />,
                          //   'Brand',
                          //   <Select
                          //     options={lineOptions}
                          //     onChange={(e) => setInteger(setBrandLine, e, 'brand_line')}
                          //     value={brandLine}
                          //   />,
                          //   <Checkbox
                          //     checked={brandLabelEnabled}
                          //     onChange={() => switchBoolean(setBrandLabelEnabled, brandLabelEnabled, 'brand_label_enabled')}
                          //   />,
                          //   <TextField value={brandLabelOverride || ''} label="" onChange={(e) => setFieldValue(setBrandLabelOverride, e, 'brand_label_override')} autoComplete="off" />
                          // ]
                        ]}
                      />
                    </BlockStack>
                  </Card>

                  <Card>
                    <BlockStack gap="200">
                      <Text variant="headingLg" as="h5">Line Settings</Text>
                      <Tabs tabs={tabs} selected={tabSelected} onSelect={handleTabChange} fitted>
                        { lineSettings.map((lineSetting, index) =>
                            <div key={index}>
                              { tabs[tabSelected].panelId === index && 
                                <BlockStack gap="200">

                                  <DescriptionList
                                    items={[
                                      {
                                        term: 'Text Overflow Strategy',
                                        description:
                                          <ChoiceList
                                            choices={[
                                              {label: 'Truncate', value: 'truncate'},
                                              {label: 'Wrap', value: 'wrap'},
                                              {label: 'Shrink-To-Fit', value: 'shrink'},
                                            ]}
                                            selected={lineSetting.render_strategy || 'truncate'}
                                            onChange={(e) => setRenderStrategy(lineSetting.position, e)}
                                          />,
                                      },
                                      {
                                        term: 'Text Placement',
                                        description:
                                          <ChoiceList
                                            choices={[
                                              {label: 'Align Left', value: 'left'},
                                              {label: 'Align Center', value: 'center'},
                                              {label: 'Align Right', value: 'right'},
                                            ]}
                                            selected={lineSetting.alignment}
                                            onChange={(e) => setAlignment(lineSetting.position, e)}
                                          />,
                                      },
                                      {
                                        term: 'Font Size',
                                        description:
                                          <TextField type="number" value={lineSetting.font_size || ''} onChange={(e) => setFontSize(lineSetting.position, e)} autoComplete="off" />,
                                      },
                                      {
                                        term: 'Text Color',
                                        description:
                                        <>
                                          { printType !== 'roll' &&
                                            <ColorPicker 
                                              onChange={(e) => setTextColor(lineSetting.position, e)} 
                                              color={lineSetting.text_color || { hue: 120, brightness: 0, saturation: 1 }} 
                                            />
                                          }
                                          { printType === 'roll' &&
                                            <Text>Labels printed from sheets can have text colors when using a printer with color ink. Rolls are printed on thermal printers and can only be black and white.</Text>
                                          }
                                        </>
                                      }
                                    ]}
                                  />

                                  <Divider />

                                  <TemplateLineOrderContainer
                                    barcode={barcodeEnabled && (index === barcodeLine)}
                                    storeLogo={storeLogoEnabled && (index === storeLogoLine)}

                                    barcodeSymbol={barcodeSymbolEnabled && (index === barcodeSymbolLine)}
                                    sku={skuEnabled && (index === skuLine)}
                                    productName={productNameEnabled && (index === productNameLine)}
                                    optionOne={optionOneEnabled && (index === optionOneLine)}
                                    optionTwo={optionTwoEnabled && (index === optionTwoLine)}
                                    optionThree={optionThreeEnabled && (index === optionThreeLine)}
                                    price={priceEnabled && (index === priceLine)}
                                    brand={brandEnabled && (index === brandLine)}
                                    arbitraryText={arbitraryTextEnabled && (index === arbitraryTextLine)}

                                    barcodeSymbolPriority={barcodeSymbolPriority}
                                    skuPriority={skuPriority}
                                    productNamePriority={productNamePriority}
                                    optionOnePriority={optionOnePriority}
                                    optionTwoPriority={optionTwoPriority}
                                    optionThreePriority={optionThreePriority}
                                    pricePriority={pricePriority}
                                    brandPriority={brandPriority}
                                    arbitraryTextPriority={arbitraryTextPriority}

                                    increasePriority={increasePriority}
                                    decreasePriority={decreasePriority}
                                  />

                                </BlockStack>
                              }
                            </div>
                          )
                        }
                      </Tabs>
                    </BlockStack>
                  </Card>
                </BlockStack>
              </FormLayout>
            </Layout.Section>
            
            <Layout.Section variant="oneThird">
              <BlockStack gap="200">
                <Card background="bg-surface-info">
                  <Text variant="headingLg" as="h5">Preview</Text>
                  <Box background="bg-surface-info">
                    { barcodeTemplates.previewUri &&
                      <Document className="pdf-document" file={{ url: barcodeTemplates.previewUri }} loading={<LoadingSpinner size="small" statusText="Loading Preview" />} onLoadSuccess={() => readyPreview()}>
                        <Page
                          className="pdf-page"
                          pageNumber={1} 
                          renderTextLayer={false}
                          renderAnnotationLayer={false}
                        />
                      </Document>
                    }
                    { barcodeTemplates.errors &&
                      <Text tone="critical">
                        Failed to load preview
                      </Text>
                    }
                  </Box>
                </Card>

                { (validationErrors.length > 0) &&
                  <Card background="bg-surface-critical">
                    <Text variant="headingLg" as="h5">Template Errors</Text>
                      <List type="bullet">
                        { validationErrors.map((error, index) =>
                          <List.Item key={index}>
                            {error} 
                          </List.Item>
                        )}
                      </List>
                  </Card>
                }
              </BlockStack>
            </Layout.Section>
          </Layout>

          <PageActions
            primaryAction={<Button icon={SaveIcon} disabled={validationErrors.length > 0} variant="primary" onClick={() => handleSubmit()}>Save Template</Button>}
          />
        </>
      }
      { (barcodeTemplates.status !== 'success' || barcodeTemplates.isFetching) &&
        <>
          <LoadingPlaceholder />
        </>
      }

      <PageFooter stripeBackground='#5bc6cc' helpLink="shopify/manage-barcode-label-templates-3/" helpDescription="setting up label templates" />
    </ShopifyPage>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  barcodeTemplates: state.barcodeTemplates,
  allTemplates: state.barcodeTemplates.templates,
  newTemplate: state.barcodeTemplates.newTemplate,
  templateFungibles: state.barcodeTemplates.templateFungibles,
  templateLineSettings: state.barcodeTemplates.templateLineSettings,
});

const mapDispatchToProps = (dispatch) => ({
  getTemplates: (shopUrl, payload) => dispatch(indexBarcodeTemplates(shopUrl, payload)),
  saveTemplateChanges: (shopUrl, payload, options) => dispatch(updateBarcodeTemplate(shopUrl, payload, options)),
  loadPreview: (shopUrl, payload, options, values) => dispatch(previewBarcodeTemplate(shopUrl, payload, options, values)),
  loadFungibles: (shopUrl, payload, uuid) => dispatch(getTemplateFungibles(shopUrl, payload, uuid)),
  loadLineSettings: (shopUrl, payload, uuid) => dispatch(getTemplateLineSettings(shopUrl, payload, uuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTemplateForm);